module.exports = __webpack_public_path__ + "static/media/david.07b5bf90.png";